export default "__VITE_ASSET__DBzu0F7f__";